import { noop } from 'lodash-es'

import { findChanges, getLayerMetadata } from '../lib/historicalImagery'
import { formatDate, /* getCurrentSeason, */ isEqual, reverseArray } from '../lib/utils'
import { getHistoricalImagery } from '../services/historicalImagery'
import { MAP_LAYER_IDS, MAP_MODES } from '../lib/constants'

export default {
  namespace: 'historicalImagery',
  state: {
    captureDate: null,
    currentLayer: {},
    dictioary: {},
    filteredList: [],
    is3DRestricted: true,
    isBasemapPinned: false,
    isLoading: false,
    isNavigatingMap: false,
    isReady: true,
    isRefreshing: false,
    list: [],
    selectedItem: null,
    selectedLayer: null,
    stepper: {},
    timeoutIds: [],
    watchHandle: null
  },
  effects: {
    *getImageryList({ callback = noop }, { call, put }) {
      const { success, data } = yield call(getHistoricalImagery)
      if (success && Object.keys(data).length > 0) {
        const dictionary = {}
        const list = []
        let date = null
        let item = null
        for (let key in data) {
          date = new Date(data[key].itemTitle?.replace(/[^\-\d]/g, ''))
          item = {
            itemDate: date.getTime(),
            // itemDateLabel: date.toLocaleDateString('en-us', { day: '2-digit', month: 'long' }),
            itemId: +key,
            itemPortalId: data[key].itemID,
            // itemSeasonLabel: `${getCurrentSeason(date)} '${date.getFullYear() % 100}`,
            itemURL: data[key].itemURL,
            metadataItemId: data[key].metadataLayerItemID,
            metadataURL: data[key].metadataLayerUrl
          }
          list.push(item)
          dictionary[item.itemId] = item
        }
        const sortedList = list.sort((a, b) => {
          if (a.itemDate > b.itemDate) return -1
          else if (a.itemDate < b.itemDate) return 1
          else return 0
        })
        yield put({ type: 'setDictionary', payload: dictionary })
        yield put({ type: 'setList', payload: sortedList })
      }
      callback(success)
    },
    *getMapCaptureDate({ payload }, { call, put, select }) {
      if (payload && Object.keys(payload).length === 3) {
        let captureDate = null
        if (payload.zoom < 0) {
          const { zoomLevel } = yield select(model => model.map)
          payload.zoom = +zoomLevel
        }
        const historicalMetadata = yield call(getLayerMetadata, payload)
        if (historicalMetadata?.captureDate) {
          captureDate = formatDate(historicalMetadata.captureDate, 'MMM D, YYYY')
        }
        yield put({ type: 'setCaptureDate', payload: captureDate })
      }
    },
    *getMapChanges({ callback = noop, payload }, { call, put, select }) {
      let newSelectedItem = null
      if (payload && Object.keys(payload).length >= 3) {
        const { filteredList, list, selectedItem } = yield select(model => model.historicalImagery)
        let getNewMapChanges = false
        if (payload.zoom < 0) {
          const { zoomLevel } = yield select(model => model.map)
          payload.zoom = +zoomLevel
        }
        if (!filteredList.length) {
          getNewMapChanges = true
          if (payload.zoom > 19) {
            payload.zoom = 19
          }
        }
        if (payload.zoom < 20) {
          getNewMapChanges = true
        }
        if (getNewMapChanges) {
          const newFilteredList = yield call(findChanges, { imageryList: list, point: payload })
          if (!isEqual(newFilteredList, filteredList)) {
            const reversedList = reverseArray(newFilteredList)
            const stepperPayload = { value: reversedList.length - 1, values: [] }
            newSelectedItem = reversedList[reversedList.length - 1]
            if (selectedItem) {
              const itemIndex = reversedList.findIndex(rfl => rfl.itemId === selectedItem.itemId)
              if (itemIndex > -1) {
                newSelectedItem = reversedList[itemIndex]
                stepperPayload.value = itemIndex
              }
            }
            for (let rli = 0; rli < reversedList.length; rli++) {
              stepperPayload.values.push(rli)
            }
            yield put({ type: 'setStepper', payload: stepperPayload })
            yield put({ type: 'setFilteredList', payload: reversedList })
          }
        }
      }
      callback(newSelectedItem)
    },
    *setNewLayers({ callback = noop, payload }, { put, select }) {
      if (payload?.id) {
        const { mapRef } = yield select(model => model.map)        
        const layersToRemove = []

        const historicalLayer = mapRef.findLayerById(MAP_LAYER_IDS.historical)
        if (historicalLayer) {
          const mapLayerItems = mapRef.layers.items
          for (let li = 0; li < mapLayerItems.length; li++) {
            if (mapLayerItems[li].id === MAP_LAYER_IDS.historical) {
              layersToRemove.push(mapLayerItems[li])
            } else {
              break
            }
          }
        } else {
          setTimeout(() => {
            const baseLayers = mapRef.basemap.baseLayers
            for (let baseLayer of baseLayers) {
              baseLayer.visible = false
            }           
          }, 500)
        }
        mapRef.layers.add(payload, layersToRemove.length)

        if (layersToRemove.length > 0) {
          const { timeoutIds } = yield select(model => model.historicalImagery)
          if (timeoutIds.length > 0) {
            for (let timeoutId of timeoutIds) {
              clearTimeout(timeoutId)
            }
          }
          const newTimeoutId = setTimeout(() => {
            mapRef.layers.removeMany(layersToRemove)
          }, 500)
          yield put({ type: 'setTimeoutIds', payload: newTimeoutId })
        }
        yield put({ type: 'setSelectedLayer', payload })
      }
      callback()
    },
    *removeDuplicateLayers({ callback = noop, payload = {} }, { put, select }) {
      const { mapMode, mapViewRef, sceneViewRef } = yield select(model => model.map)
      const viewRef = mapMode === MAP_MODES.ThreeD ? sceneViewRef : mapViewRef
      const mapLayerItems = viewRef.map.layers.items
      const currentLayers = []
      for (let mli = 0; mli < mapLayerItems.length; mli++) {
        if (mapLayerItems[mli].id === MAP_LAYER_IDS.historical) {
          currentLayers.push(mapLayerItems[mli])
        }
      }
      if (currentLayers.length > 1) {
        const layersToRemove = currentLayers.slice(1)
        const { timeoutIds } = yield select(model => model.historicalImagery)
        if (timeoutIds.length > 0) {
          for (let ti = 0; ti < timeoutIds.length; ti++) {
            clearTimeout(timeoutIds[ti])
          }
        }
        const newTimeoutId = setTimeout(() => {
          viewRef.map.removeMany(layersToRemove)
        }, payload.seconds)
        yield put({
          type: 'setTimeoutIds',
          payload: newTimeoutId
        })
      }
      callback()
    },
    *removeLayers({ callback = noop, payload = {} }, { put, select }) {
      const { basemapMode, mapRef } = yield select(model => model.map)
      const { removeWatchHandle = false, toggleBasemap = false } = payload
      const layersToRemove = []
      const mapLayerItems = mapRef.layers.items
      for (let li = 0; li < mapLayerItems.length; li++) {
        if (MAP_LAYER_IDS.historical === mapLayerItems[li].id) {
          layersToRemove.push(mapLayerItems[li])
        } else {
          break
        }
      }
      if (toggleBasemap) {
        const baseLayerId = MAP_LAYER_IDS.basemap[basemapMode.toLowerCase()]
        const baseLayer = mapRef.basemap.baseLayers.items.find(i => i.id === baseLayerId)
        if (baseLayer) baseLayer.visible = true
      }
      if (layersToRemove.length > 0) {
        setTimeout(() => {
          mapRef.layers.removeMany(layersToRemove)
        }, 500)
      }
      if (removeWatchHandle) {
        const { watchHandle } = yield select(model => model.historicalImagery)
        if (watchHandle) {
          watchHandle.remove()
          yield put({
            type: 'setWatchHandle',
            payload: null
          })
        }
      }
      callback()
    }
  },
  reducers: {
    setFilteredList(state, { payload }) {
      return {
        ...state,
        filteredList: payload
      }
    },
    setList(state, { payload }) {
      return {
        ...state,
        list: payload
      }
    },
    setDictionary(state, { payload }) {
      return {
        ...state,
        dictionary: payload
      }
    },
    setSelectedLayer(state, { payload }) {
      return {
        ...state,
        selectedLayer: payload
      }
    },
    setSelectedItem(state, { payload }) {
      return {
        ...state,
        selectedItem: payload
      }
    },
    setSelected(state, { payload }) {
      return {
        ...state,
        ...payload
      }
    },
    setIsLoading(state, { payload }) {
      return {
        ...state,
        isLoading: payload
      }
    },
    setIsBasemapPinned(state, { payload }) {
      return {
        ...state,
        isBasemapPinned: payload
      }
    },
    setStepper(state, { payload }) {
      return {
        ...state,
        stepper: {
          ...state.stepper,
          ...payload
        }
      }
    },
    setSlideshow(state, { payload }) {
      return {
        ...state,
        sliderState: payload
      }
    },
    setLayers(state, { payload }) {
      return {
        ...state,
        layers: {
          ...state.layers,
          ...payload
        }
      }
    },
    setIsRefreshing(state, { payload }) {
      return {
        ...state,
        isRefreshing: payload
      }
    },
    setIsReady(state, { payload }) {
      return {
        ...state,
        isReady: payload
      }
    },
    setIsNavigatingMap(state, { payload }) {
      return {
        ...state,
        isNavigatingMap: payload
      }
    },
    setTimeoutIds(state, { payload }) {
      return {
        ...state,
        timeoutIds: [...state.timeoutIds, payload]
      }
    },
    setWatchHandle(state, { payload }) {
      return {
        ...state,
        watchHandle: payload
      }
    },
    setCaptureDate(state, { payload }) {
      return {
        ...state,
        captureDate: payload
      }
    }
  }
}
